import { FormControl, InputLabel } from "@mui/material";
import SearchableSelect from "./SearchableSelect";

const Select = (props) => {
  const { children, fullWidth, ...rest } = props;
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel id="lId" color={rest?.color}>
        {rest?.label}
      </InputLabel>
      <SearchableSelect labelId="lId" {...rest}>
        {children}
      </SearchableSelect>
    </FormControl>
  );
};
export default Select;
